@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.worktasks.worktasks' | translate }}</h2>
	<div class="service-header-buttons">
		<button mat-flat-button color="primary" (click)="toggleShowInactive()">
			{{ 'mes.administration.worktasks.is-active.' + showInactive | translate }}
		</button>
		<div class="acies-density-high acies-list-search-field margin-left-8">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'mes.administration.worktasks.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<table class="table-responsive" mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.worktasks.alias' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.name }}</td>
	</ng-container>

	<ng-container matColumnDef="category">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.worktasks.category' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.category }}</td>
	</ng-container>

	<ng-container matColumnDef="salary">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.worktasks.salary-type' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.salary }}</td>
	</ng-container>

	<ng-container matColumnDef="terminal">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.worktasks.terminal' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.terminal }}</td>
	</ng-container>

	<ng-container matColumnDef="isActive">
		<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
			{{ 'mes.administration.users.isActive.label' | translate }}
		</th>
		<td mat-cell *matCellDef="let element" style="text-align: center">
			<mat-icon svgIcon="{{ element.isActive ? 'acies_true' : 'acies_false' }}" [ngClass]="element.isActive ? 'greenColor' : 'redColor'"></mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="menu">
		<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
		<td mat-cell *matCellDef="let row" style="text-align: end">
			<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Edit user settings">
				<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				@if (!row.isActive) {
					<button mat-menu-item (click)="onToggleActive(row.task)">
						<span>{{ 'mes.administration.worktasks.activatebtn' | translate }}</span>
					</button>
				}
				@if (row.isActive && row.id != offstampId) {
					<button mat-menu-item (click)="onToggleActive(row.task)">
						<span>{{ 'mes.administration.worktasks.deactivatebtn' | translate }}</span>
					</button>
				}
				<button mat-menu-item (click)="openWorktask(row.task)">
					<span>{{ 'mes.administration.worktasks.editbtn' | translate }}</span>
				</button>
			</mat-menu>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
